import { REDUCER } from '../reducers/reducersConst';

export const setErrorData = (code = '404', description = 'errorPage.description.notFound') => {
  return dispatch => {
    dispatch(setErrorCode(code));
    dispatch(setErrorDescription(description));
  };
};

const setErrorCode = (code = undefined) => {
  return {
    type: REDUCER.ERROR.SET_CODE,
    code
  };
};

const setErrorDescription = (description = undefined) => {
  return {
    type: REDUCER.ERROR.SET_DESCRIPTION,
    description
  };
};
